import { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";

const useTodayOpeningOverride = () => {
    const data = useStaticQuery(graphql`
        query TodayOpeningOverrideQuery {
            siteSettings: sanitySiteSettings {
                hours {
                    title
                    hours {
                        date(formatString: "YYYY-MM-DD")
                        startHour
                        endHour
                    }
                }
            }
        }
    `);

    const hours = useMemo(() => {
        const hoursArray = data?.siteSettings?.hours || {};

        return hoursArray;
    }, [data]);

    return { hours };
};

export default useTodayOpeningOverride;
